import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'
import { EndAbTestContext } from '../../../context/EndAbTestContext'
import { Schema } from '../../schema'
import { Data, END_AB_TEST, mapper } from './api'
import { UseEndAbTest } from './types'

export const useEndAbTest = (): UseEndAbTest => {
  const { workspaceId } = useWorkspaceParam()
  const navigate = useNavigate()
  const { t } = useTranslation('features/abTests', { keyPrefix: 'endTest' })
  const { enqueueSnackbar } = useSnackbar()
  const { setLoading, setOpen } = useContext(EndAbTestContext)

  const [mutate] = useMutation(END_AB_TEST, {
    onCompleted: ({ endAbTest: { errors } }: Data): void => {
      setLoading(false)
      setOpen(false)
      navigate(generatePath(ROUTES.AB_TESTS.LIST, { workspaceId }))

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error'), { variant: 'success' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    refetchQueries: ['getAbTests'],
  })

  const endAbTest = (input: Schema) => {
    mutate({ variables: { input: mapper(input) } })
  }

  return {
    endAbTest,
  }
}
